import Cta from '@/components/cta/cta';
import Leaf from '@/components/icon/leaf';

export default function CtaBanner({ className, text, isDark = false }) {
  return (
    <aside
      className={`flex items-center justify-between gap-x-(--space-6) px-5 h-19 mt-6 overflow-hidden rounded-lg lg:mt-9 lg:h-24 ${isDark ? 'bg-white/10 text-white' : 'bg-white/70 text-main-dark'}${className ? ` ${className}` : ''}`}
      aria-label="Call to action"
    >
      <div className="flex items-center gap-x-4">
        <Leaf className="shrink-0 text-main-green" aria-hidden="true" />
        <p className="body-2-sans-small text-pretty xl:body-2-sans">{text}</p>
      </div>

      <Cta
        className="cta shrink-0"
        href="http://ancestry.com/story-scout"
      >
        Start now
      </Cta>
    </aside>
  );
}
